<template lang="pug">
  div.map-container.navigation-control
    div.toolbar.toolbar--big.toolbar--bordered
      div.line
        h1.title Карта
        form.search
          input(type="search" placeholder="")

    div.new-map
      div#map.bigmap
      transition(name="fade")
        div.legend.map-routes.cuscroll(:class="showRight ? 'open' : 'close'")
          div.head(@click="showRight = !showRight")
            h2.title Маршруты
            div.legend-info
            span.legend__close(v-if="showRight")
            span.legend__open(v-else)

          div.type-group.type-group--small-pad
            div.add-address
              button.actions-panel__button.btn-add.green.small
              span Добавить адрес

          div.type-group.type-group--noborder.route
            table
              thead
                th № Маршрута
                th Периодичность
                th Протяжение (км)
                th
              tbody
                tr(onclick="window.location.href='#/verstka/route-one'; return false")
                  td №12
                  td Ежедневный
                  td 12
                  td
                    span.close--small
                tr(onclick="window.location.href='#/verstka/route-one'; return false")
                  td №12
                  td Ежедневный
                  td 12
                  td
                    span.close--small

          div.type-group.type-group--noborder.route-create
            button.route-create__button Автосоставление маршрутов


</template>

<script>
  import 'leaflet';

  window.L = L;

  export default {
    data() {
      return {
        showRight: true,
        map: [],
        markers: null
      };
    },
    methods: {
      initmap3() {
        this.map = L.map('map', {
          center: [56.84325131, 60.60611655],
          zoom: 17
        });
        L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(this.map);
      }
    },
    mounted() {
      this.$store.dispatch('initelements');
      this.initmap3();
    }
  };
</script>

<style lang="scss">
  @import "../../../../node_modules/leaflet/dist/leaflet.css";
</style>
